import { cn } from '../../lib/utils.ts';
import seasonalLogoWithText from './plato-logo-with-text-seasonal.png';

type Props = {
    className?: string;
};

/**
 * Seasonal variant of the Plato wordmark, shown in the main navigation during the
 * windows defined in `lib/seasonal-logo.ts`. Swap the artwork (the imported PNG)
 * per holiday.
 */
export function PlatoLogoWithTextSeasonal({ className = '' }: Props) {
    return <img src={seasonalLogoWithText} alt="Plato" className={cn('h-7 w-auto', className)} />;
}
